import React, { useEffect, useState } from 'react';
import { FileUploader, type FileRow } from 'baseui/file-uploader';
import type { EnhancedQuestion, Answer, ProcessFileOnDrop } from '../../types';
export type FileInputProps = {
  question: EnhancedQuestion;
  answer?: Answer;
  setAnswerForQuestion: (questionId: string, answers: string[]) => void;
  processFileOnDrop?: ProcessFileOnDrop;
};
const defaultProcessFileOnDrop: ProcessFileOnDrop = async (file, fileId) => {
  return {
    errorMessage: null,
    fileInfo: {
      url: URL.createObjectURL(file)
    }
  };
};
const FileInput = ({
  question,
  answer,
  setAnswerForQuestion,
  processFileOnDrop = defaultProcessFileOnDrop
}: FileInputProps): React.ReactElement => {
  const [fileRows, setFileRows] = useState<FileRow[]>(() => {
    const existingUrls = answer?.answers ?? [];
    return existingUrls.map((url, index) => ({
      errorMessage: null,
      file: new File([], 'File ' + (index + 1)),
      id: 'existing-' + index,
      fileInfo: {
        url
      },
      imagePreviewThumbnail: url,
      progressAmount: 100,
      status: ('processed' as const)
    }));
  });

  // Sync fileRows back to answer when files change
  useEffect(() => {
    const processedFiles = fileRows.filter(row => row.status === 'processed' && !row.errorMessage);
    const urls = processedFiles.flatMap(row => row.fileInfo?.url ? [row.fileInfo.url] : []);
    const currentUrls = answer?.answers ?? [];
    const urlsChanged = JSON.stringify(urls) !== JSON.stringify(currentUrls);
    if (urlsChanged) {
      setAnswerForQuestion(question.id, urls);
    }
  }, [fileRows, answer?.answers, question.id]);
  return <FileUploader fileRows={fileRows} setFileRows={setFileRows} itemPreview processFileOnDrop={processFileOnDrop} overrides={FILE_UPLOADER_OVERRIDES} />;
};
const FILE_UPLOADER_OVERRIDES = {
  FileDragAndDrop: {
    style: ({
      $theme
    }) => ({
      borderColor: $theme.colors.borderOpaque,
      borderStyle: 'dashed'
    })
  },
  ContentMessage: {
    style: ({
      $theme
    }) => ({
      color: $theme.colors.contentSecondary
    })
  }
};
export default FileInput;